import Global from '../global';
import LocaleConfigFile from './kambi/settings-config/locale';
import CurrencyConfigFile from './kambi/settings-config/currency';
import KambiOptionsConfigFile from './kambi/settings-config/kambi-options';
import { getKambiLinksConfig } from './kambi/settings-config/kambi-links';
import getMarketsConfig from './kambi/settings-config/markets';

import BrandSettingsConfigFile from './kambi/settings-config/brand-settings';
import getOfferingConfig from './kambi/offering';

import CrossSale from './cross-sale/cross-sale-mappings';
import ExternalContentConfig from '../components/main/external-content/external-content-config/index';

let mapLangISO2ToLocale = function (langISO2) {
  langISO2 = langISO2.toLowerCase();

  let arrayOfLocales = LocaleConfigFile[langISO2];

  if (arrayOfLocales) {

    return {
      langISO2: langISO2,
      locale: arrayOfLocales[arrayOfLocales.length - 1]
    };

  } else {
    Global.logger.log('["MAPPING WAS NOT FOUND.... DEFAULTING TO EN_GB"]');

    let defaultIso2 = LocaleConfigFile['other'];
    return {
      langISO2: defaultIso2,
      locale: LocaleConfigFile[defaultIso2]
    };
  }
};

let lookForCountryinConfig = function (countryISO3, config) {
  for (let market in config) {
    if (config.hasOwnProperty(market)) {
      const countries = config[market];
      const isCountryFound = countries.some(country => country === countryISO3);
      if (isCountryFound) {
        return market;
      }
    }
  }
};

let getMarketForCountry = function (countryISO3, brandId) {
  const marketsConfig = getMarketsConfig();
  countryISO3 = countryISO3.toUpperCase();
  let market;

  const brandedConfigOption = marketsConfig[brandId];

  if (brandedConfigOption) {
    if (typeof brandedConfigOption == 'string') // check if directly the market is specified
      return brandedConfigOption;
    else if (brandedConfigOption.constructor === Array) // check if market depends on country
      market = lookForCountryinConfig(countryISO3, brandedConfigOption);
  }
  else {
    const defaultOption = marketsConfig.others;
    market = lookForCountryinConfig(countryISO3, defaultOption);
  }

  return market || marketsConfig.default;
};


let parseCurrency = function (countryIso3, brand) {
  countryIso3 = countryIso3.toUpperCase();
  let rulePassed = CurrencyConfigFile.rules.find((rule) => {
    const { conditions } = rule;
    const { brands, countries } = conditions;
    return Object.keys(conditions).reduce((accumulator, currentKey) => {
        switch (currentKey) {
          case 'brands':
            return accumulator || brands.indexOf(brand) >= 0;
          case 'countries':
            return accumulator || countries.indexOf(countryIso3) >= 0;
          default:
            return accumulator;
        }
      },
      false);
  });

  if (rulePassed)
    return rulePassed.currency;

  return CurrencyConfigFile.default;
};


let parseKambiOptions = function (countryISO3) {
  countryISO3 = countryISO3.toUpperCase();
  const oddsFormatPerCountry = KambiOptionsConfigFile.oddsFormat[countryISO3];

  return {
    ...KambiOptionsConfigFile,
    'oddsFormat': oddsFormatPerCountry ? oddsFormatPerCountry : KambiOptionsConfigFile.oddsFormat['default']
  };

};

function parseKambiLinks(brand, langISO2, countryISO3) {
  langISO2 = langISO2.toLowerCase();
  countryISO3 = countryISO3.toUpperCase();
  let config = getKambiLinksConfig(brand, langISO2);
  let brandedSettings = config[brand] ? config[brand] : null;
  let countrySettings = brandedSettings ? (brandedSettings[countryISO3] || brandedSettings.default) : null;

  let betSlipLinks = countrySettings && countrySettings.betSlipLinks ? countrySettings.betSlipLinks : [];
  let betHistoryLinks = countrySettings && countrySettings.betHistoryLinks ? countrySettings.betHistoryLinks : [];

  let links = {
    betslipLinks: {},
    bethistoryLinks: {}
  };
  betSlipLinks.forEach((item, index) => {
    links.betslipLinks[`linkbetslip${index}`] = item;
  });
  betHistoryLinks.forEach((item, index) => {
    links.bethistoryLinks[`linkbethistory${index}`] = item;
  });

  return links;
}

/*
function getDefaultBetLinks(linkCategory, prefix, links, listOfLinks) {
  let defaultBetLinks = {};

  links.forEach((typeOfBet) => {
    defaultBetLinks[prefix + typeOfBet] = {
      ...listOfLinks[linkCategory][prefix + typeOfBet]
    }
  });

  return defaultBetLinks;
}

function getModifiedBetlinks(defaultLinks, newValuesOfKambiLinks,) {
  Object.keys(defaultLinks["betslipLinks"]).forEach((key) => {
    defaultLinks["betslipLinks"][key] = {
      ...defaultLinks["betslipLinks"][key],
      ...newValuesOfKambiLinks["betslipLinks"][key]
    }

  });

  Object.keys(defaultLinks["betHistoryLinks"]).forEach((key) => {
    defaultLinks["betHistoryLinks"][key] = {
      ...defaultLinks["betHistoryLinks"][key],
      ...newValuesOfKambiLinks["betHistoryLinks"][key]
    }
  });
}

function getKambiLinksFromBrandedSettings(brandSettings, langISO2, countryISO3) {
  let countrySettings = brandSettings[countryISO3] || brandSettings["all"];

  if (countrySettings[langISO2]) {
    return countrySettings[langISO2]
  }
};*/

let parseBrandSettings = function (userContextBrand) {
  if (BrandSettingsConfigFile[userContextBrand]) {
    return BrandSettingsConfigFile[userContextBrand];
  }
};

let parseKambiOffering = function (brand, countryISO3) {
  countryISO3 = countryISO3.toUpperCase();
  const offeringConfig = getOfferingConfig();

  let rulePassed = offeringConfig.rules.find((rule) => {
    const { conditions } = rule;
    const { brands, countries } = conditions;

    const allConditionsPassed = Object.keys(conditions)
      .reduce(
        (accumulator, currentKey) => {
          switch (currentKey) {
            case 'brands':
              return accumulator && brands.indexOf(brand) >= 0;
            case 'countries':
              return accumulator && countries.indexOf(countryISO3) >= 0;
            default:
              return accumulator;
          }
        },
        true);

    return allConditionsPassed;
  });

  if (rulePassed) {
    return rulePassed.offering;
  }

  return offeringConfig.default;
};


let getExternalContentData = function (brand, subBrand, component) {
  const allContentConfig = ExternalContentConfig();
  const specificContentConfig = (allContentConfig[brand]
    && allContentConfig[brand][subBrand]
    && allContentConfig[brand][subBrand][component])
    || null;

  return specificContentConfig;
};

let shouldShowCrossSellLink = function (crossSellLinkType, subBrand) {
  return CrossSale[crossSellLinkType] && CrossSale[crossSellLinkType].includes(subBrand);
};


export default {
  getMarketForCountry: getMarketForCountry,
  parseCurrency: parseCurrency,
  parseKambiOptions: parseKambiOptions,
  mapLangISO2ToLocale: mapLangISO2ToLocale,
  parseKambiLinks: parseKambiLinks,
  parseBrandSettings: parseBrandSettings,
  parseKambiOffering: parseKambiOffering,
  getExternalContentData: getExternalContentData,
  shouldShowCrossSellLink: shouldShowCrossSellLink
};

